import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import swal from 'sweetalert/dist/sweetalert.min.js';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from "rxjs/internal/operators";

@Component({
  selector: 'app-regis',
  templateUrl: './regisupdate.component.html',
  styleUrls: ['./regis.component.css']
})
export class RegisupdateComponent implements OnInit {
  // @ViewChild('openModal', { static: false }) openModal: ElementRef;
  @ViewChild('verifikasi', { static: false }) verifikasi: ElementRef;
  @ViewChild('agmmarker', { static: false }) agmmarker: ElementRef;
  @ViewChild('otpinput1', { static: false }) otpinput1: ElementRef;
  @ViewChild('otpinput2', { static: false }) otpinput2: ElementRef;
  @ViewChild('otpinput3', { static: false }) otpinput3: ElementRef;
  @ViewChild('otpinput4', { static: false }) otpinput4: ElementRef;
  @ViewChild('otpinput5', { static: false }) otpinput5: ElementRef;
  @ViewChild('otpinput6', { static: false }) otpinput6: ElementRef;


  inputPostalcode: Subject<string> = new Subject<string>();

  constructor(
    private fb: FormBuilder,
    private mapsAPILoader: MapsAPILoader,
    public rest:ApiContentService,
    private route:ActivatedRoute,
    private router: Router
  ) {}

  registerForm: any
  latitude: number
  longitude: number
  zoom: number
  message: any
  submitted = false
  refid = ''
  loadingIcon:any = {}
  regis:any = []
  provinces:any = []
  cities:any = []
  districts:any = []
  subdistricts:any = []
  data_kml:any = []
  tea:any = []
  data_prospek:any = {}
  data_prospek_srt:any = []
  // prospekindex:any = 0
  prospekindex:any = 0
  dataprospek:any = 0
  otpinput:any = {}
  countTimeout:any = 0
  generate1:any = false
  codeotpran:any = 0

  hometype:any = []
  homestatus:any = []
  typeidentity:any = []
  typerelative:any = []

  fileData:File = null
  previewUrl:any = null
  image:any

  showRef = false
  isRef = false
  validRef = false
  dataPost:any = []
  iserror = false
  errors : any;
  strerror = ''

  ngOnInit(): void {

    this.loadingIcon = {
      'next':false,
      'invalid': false,
      'showFormsrt': true,
      'showSrt': false,
      'notif': false,
      'notif_upload': false,
      'last_task': true
    }
    
    let params = this.route.snapshot.paramMap.get('encrypt')
    var decrypt = atob(params)
    decrypt = decrypt.replace('_xx_','+').replace('_mm_','/')
    var arrs = decrypt.split('_vv_')
    this.prospekindex = arrs[1]
    this.checkProspekUpdateExpired()
    
  }

  checkProspekUpdateExpired(){
    // console.log(prospekid);
    const params = {
      'prospekindex' : this.prospekindex
    }
    this.rest.checkProspekUpdateExpired(params).subscribe((response:any) => {
      if (response.status) {
        this.loadingIcon.invalid = false;
        this.data_prospek_srt = response.data.prospek_srt
        this.data_prospek = response.data.prospek

        this.data_prospek_srt.forEach((row:any) => {
          row.classbtn_agree = "btn btn-secondary btn-press"
          row.classbtn_disagree = "btn btn-secondary btn-press"
          if(row.idsrt != 5){
            this.loadingIcon.showSrt = true
            if(row.idsrt == 4){
              row.srtaddinfo = {}
              row.srtaddinfo['addinfo'] = "1"
            }
          }
        })

      }else{
        this.loadingIcon.invalid = true;
      }
      this.message = response.message
    });
  }

  change_sts(row:any,status:number){
    row.srtstatus = status
    if(row.srtstatus == 1){
      row.classbtn_agree = "btn btn-success btn-press"
      row.classbtn_disagree = "btn btn-secondary btn-press"
    }else{
      row.classbtn_agree = "btn btn-secondary btn-press"
      row.classbtn_disagree = "btn btn-danger btn-press"
    }
  }

  onNextfoto(){
    this.loadingIcon.showFormsrt = true
    this.loadingIcon.showSrt = false
  }

  onNext(){

    this.dataPost = []

    swal({
      title: "Are you sure?",
      text: "Form akan disubmit",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false
    })
    .then((confirm:any) => {
        if (confirm) {
          this.data_prospek_srt.forEach((row:any) => {
            if(row.idsrt == 5){
              this.loadingIcon.last_task = false
              if(this.loadingIcon.showSrt != true){
                  if(this.image == undefined){
                    swal({
                      title: "Data Belum Lengkap",
                      text: "Maaf Data yang anda Input, ada yang belum terisi.",
                      icon: "error",
                    });
                    return
                  }else{
                    row.value = this.image
                    row.srtstatus = 1;
                    this.dataPost.push(row)
                    this.loadingIcon.last_task = true
                  }
                }
            }else{
              if(row.srtstatus == null){
                swal({
                  title: "Data Belum Lengkap",
                  text: "Maaf Data yang anda Input, ada yang belum terisi.",
                  icon: "error",
                });
                return
              }
              if(this.loadingIcon.showSrt == true){
                this.dataPost.push(row)
              }
            }
          })

          console.log(this.data_prospek_srt)

          this.regis = {
            'data_prospek_srt':this.dataPost,
            // 'identity_image': this.image,
            'prospekindex': this.prospekindex,
            'last_task': this.loadingIcon.last_task
          }
          this.loadingIcon.next = true

          this.rest.setUpdateprospek(this.regis).subscribe((response:any) => {

            this.loadingIcon.next = false
            if (response.status == true) {
              this.loadingIcon.showFormsrt = false
              this.loadingIcon.notif = true
            }else{
              this.errors = response.errors;
              this.iserror = true;
              this.errors.forEach((row:any) => {
                if ( this.strerror != '') {
                  this.strerror += ', '+row.message ;
                }else{
                  this.strerror = row.message ;
                }
              })
              console.log(this.errors);
            }

            this.data_prospek_srt.forEach((row:any) => {
              if(row.srtstatus == 2){
                this.loadingIcon.notif = false
                return
              }
            })
            this.loadingIcon.showFormsrt = false

            this.dataPost.forEach((row:any) => {
              if(row.idsrt == 5){
                this.loadingIcon.notif_upload = true
              }
            })

          });
        }
    })
  }

  reloadCurrentPage() {
    window.location.reload();
   }


  sendSms(dataPost:any){
    const params = {
      "code_otp": dataPost.otp_code,
      "phone_number": dataPost.phone_number,
      "prospek_index": dataPost.prospekindex
    }
    this.rest.sendSmsotp(params).subscribe((response:any) => {
      //set otp
      console.log(response)
    });

  }

  countdown(){
    if(this.countTimeout == 0){
      this.generate1 = false
    }else{
      this.generate1 = true
      // console.log(this.count)
      setTimeout(()=>{
        this.countTimeout -=1
        this.countdown()
      }, 1000);
    }
  }

  changeBase64($event:any) {
    this.fileData = <File>$event.target.files[0]
    this.preview()
    this.readThis($event.target)

    // setTimeout(() => {
    //   this.uploadtest()
    // }, 5000);
  }
  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = reader.result; 
    }
  }
  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    var myReader:FileReader = new FileReader();

    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.image = myReader.result;
      // console.log(this.image)
    }
  }


  alertfailed(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error"
    })
  }
  alertsuccess(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
      // closeOnClickOutside: false
    })
  }
}
